import { i18n } from '@/plugins/i18n';
import { useMavenService } from '@/api/mavenService';
import { useMainStore } from '@/stores/mainStore';
import { useUserStore } from '@/stores/userStore';
import type { ApiV3 } from '@teamworksdev/influencer-core';

declare global {
	interface Window {
		Maven?: {
			ChatWidget: {
				load: (options: Record<string, any>) => void;
				show: () => void;
				open: () => void;
				close: () => void;
				hide: () => void;
			};
		};
	}
}

const { t } = i18n.global;

function initMaven() {
	const script = document.createElement('script');
	script.id = 'influencer-maven-chat-widget';
	script.src = 'https://chat.onmaven.app/js/widget.js';
	script.defer = true;
	document.head.appendChild(script);
}

let mavenUserData: ApiV3.SignedMavenUserData | null = null;

async function loadMaven() {
	const userStore = useUserStore();
	const userId = userStore.user?.uuid;

	// Only load Maven again if the user has changed
	if (mavenUserData?.id !== userId) {
		mavenUserData = await getMavenSignedUserData();

		window.Maven?.ChatWidget.load({
			organizationId: 'teamworks',
			agentId: 'support',
			bgColor: userStore.appSwitcherProfile?.navbar_bottom_color ?? '#2cc3f2',
			buttonLabel: t('navigationMenu.getHelp'),
			hideButton: true,
			signedUserData: mavenUserData!.jwt,
			tags: ['influencer'],
			showPoweredBy: false,
		});
	}
}

async function getMavenSignedUserData() {
	const mavenService = useMavenService();

	const response = await mavenService.getMavenUser();

	return response;
}

async function toggleMaven() {
	const mainStore = useMainStore();

	if (mainStore.isMavenChatOpen) {
		window.Maven?.ChatWidget.close();
		window.Maven?.ChatWidget.hide();
	} else {
		await loadMaven();
		window.Maven?.ChatWidget.show();
		window.Maven?.ChatWidget.open();
	}

	mainStore.toggleMavenChat();
}

export { initMaven, toggleMaven };
